import {
  NON_GDPR_MARKETING_CONSENT_COUNTRIES,
  UNITED_KINGDOM,
} from '../config/countries-data'
import { GDPR_COUNTRIES } from '../config/gdpr'

/**
 * Checks if a country is in the GDPR region
 * @param ipCountry - The country code to check (falls back to window.KEYS.ipCountry if not provided)
 * @returns true if the country is subject to GDPR regulations
 */
export function inGdprCountry(ipCountry?: string): boolean {
  return GDPR_COUNTRIES.includes(ipCountry || window.KEYS.ipCountry)
}

/**
 * Checks if a country requires marketing consent
 * @param ipCountry - The country code to check
 * @returns true if the country requires explicit marketing consent
 */
export function isMarketingConsentCountry(ipCountry?: string): boolean {
  return (
    inGdprCountry(ipCountry) ||
    NON_GDPR_MARKETING_CONSENT_COUNTRIES.includes(ipCountry || '')
  )
}

/**
 * Checks if a country allows soft opt-in for marketing emails
 * In the UK we can make users opt in to marketing emails as long as there is a way to opt out
 * @param ipCountry - The country code to check
 * @returns true if the country allows soft opt-in
 */
export function isSoftOptInCountry(ipCountry?: string): boolean {
  return (ipCountry && ipCountry.toUpperCase() === UNITED_KINGDOM) || false
}
